import { render } from "./dashboard.vue?vue&type=template&id=7ac7d458&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./dashboard.vue?vue&type=style&index=0&id=7ac7d458&lang=scss&module=true"
cssModules["$style"] = style0
import "./dashboard.vue?vue&type=style&index=1&id=7ac7d458&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-7ac7d458"]])

export default __exports__